import React, { useState } from 'react';
import ActionButton from './ActionButton';
import { StyledSelect } from '../../RouteExecution/Pickups/PickupManagement/components/Select';
import { isEqual } from 'lodash/lang';

const getFieldError = (field, value) => {
  switch (field) {
    case 'inboundTerminal':
      return value?.trim() ? null : '* Required';
    case 'dollyStatus':
      return value?.trim() ? null : '* Required';
    default:
      return null;
  }
};

const UpdateDolly = ({
  assetInfo,
  updateEquipment,
  terminalOptions,
  statusOptions,
  classes,
  updateInProgress,
  onClose,
  formErrorMessage,
  clearFormErrorMessage
}) => {
  const [errorMessage, setErrorMessage] = useState(null);

  const [dollyInfo, setDollyInfo] = useState({
    inboundTerminal: assetInfo?.inboundTerminal || null,
    dollyStatus: assetInfo?.dollyStatus || null
  });

  const [errorInfo, setErrorInfo] = useState(null);
  const handleChange = (name) => (value) => {
    value = value?.value || null;
    setDollyInfo((state) => ({
      ...state,
      [name]: value
    }));
    setErrorInfo((state) => ({
      ...state,
      [name]: getFieldError(name, value)
    }));
    if (errorMessage) {
      setErrorMessage(null);
    }
    if (formErrorMessage) {
      clearFormErrorMessage();
    }
  };

  const getErrorInfo = () => {
    let errorInfo = {};
    Object.keys(dollyInfo).forEach((fieldName) => {
      errorInfo[fieldName] = getFieldError(fieldName, dollyInfo[fieldName]);
    });
    setErrorInfo(errorInfo);
    return errorInfo;
  };

  const updateDolly = () => {
    const errorInfo = getErrorInfo();
    const errorData = Object.values(errorInfo).filter((value) => value).length;
    if (!errorData) {
      const data = {
        ...assetInfo,
        ...dollyInfo
      };
      if (isEqual(data, assetInfo)) {
        setErrorMessage('No changes to update');
        return;
      }
      updateEquipment({
        equipmentId: data.dollyId,
        equipmentNumber: data.dollyNumber,
        equipmentStatus: data.dollyStatus,
        equipmentScac: data.dollyScac,
        equipmentType: null,
        inboundTerminal: data.inboundTerminal,
        outboundTerminal: data.outboundTerminal
      });
    }
  };

  return (
    <>
      <div className={classes.formValue}>
        <StyledSelect
          textFieldProps={{
            id: 'DollyStatus',
            label: 'Dolly Status',
            variant: 'outlined',
            helperText: errorInfo?.dollyStatus
          }}
          value={dollyInfo?.dollyStatus}
          error={errorInfo?.dollyStatus}
          onChange={handleChange('dollyStatus')}
          data={statusOptions}
        />
      </div>

      <div className={classes.formValue}>
        <StyledSelect
          textFieldProps={{
            id: 'CurrentTerminal',
            label: 'Current Terminal',
            variant: 'outlined',
            helperText: errorInfo?.inboundTerminal
          }}
          value={dollyInfo?.inboundTerminal}
          error={errorInfo?.inboundTerminal}
          onChange={handleChange('inboundTerminal')}
          data={terminalOptions}
        />
      </div>
      {errorMessage || formErrorMessage ? (
        <div className={classes.errorMessage}>{errorMessage || formErrorMessage}</div>
      ) : null}
      <ActionButton
        classes={classes}
        onClose={onClose}
        updateInProgress={updateInProgress}
        updateEquipment={updateDolly}
        errorMessage={errorMessage}
      />
    </>
  );
};

export default UpdateDolly;
